import React, { createContext, useContext, ReactNode } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';

interface GoogleMapsContextProps {
  isLoaded: boolean;
}

const GoogleMapsContext = createContext<GoogleMapsContextProps>({ isLoaded: false });

interface GoogleMapsProviderProps {
  children: ReactNode;
}

export const GoogleMapsProvider: React.FC<GoogleMapsProviderProps> = ({ children }) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.NX_PUBLIC_MAP_API_KEY || '',
    libraries: ['places','drawing','visualization','geometry','marker'],
  });

  return (
    <GoogleMapsContext.Provider value={{ isLoaded }}>
      {children}
    </GoogleMapsContext.Provider>
  );
};

export const useGoogleMaps = (): GoogleMapsContextProps => useContext(GoogleMapsContext);
